













































import Vue from 'vue';
import { ValidationObserver } from 'vee-validate';
import { get, cloneDeep } from 'lodash';
import { mapState } from 'vuex';
import { VueEditor } from 'vue2-editor';

import editorToolbar from '@/web/utils/editor-toolbar';

export default Vue.extend({
  components: {
    ValidationObserver,
    //VueEditor,
  },
  props: {
    instructor: {
      type: Object,
      default() {
        return {
          bio: null,
          id: null,
          image: null,
          name: null,
          position: null,
          views: null,
        };
      },
    },
  },
  data() {
    return {
      instructorModel: {},
      formError: null,
      customToolbar: editorToolbar,
      file: null,
    };
  },
  computed: {
    ...mapState('mediaLibrary', ['instructors']),
  },
  methods: {
    async submitInstructor() {
      const dispatchAction = this.instructor.id
        ? 'mediaLibrary/updateInstructor'
        : 'mediaLibrary/createInstructor';

      try {
        const dispatchPromise = await this.$store.dispatch(dispatchAction, {
          ...this.instructorModel,
          image: this.instructorModel.image?.id || null,
        });
        await this.$store.dispatch('mediaLibrary/getInstructors');
        this.$emit('close');
        this.$emit('onSubmit', dispatchPromise);
      } catch (error) {
        this.formError = get(error, 'response.data.non_field_errors[0]', null);
      }
    },
  },
  mounted() {
    if (this.instructor.position === null)
      this.instructor.position = this.instructors.length;
    this.instructorModel = cloneDeep(this.instructor);
  },
});
